import { Routes } from '@angular/router';

/**
 * Catalogo dei componenti (FR-053), solo nelle build `development` e `staging`. Nella build
 * `production` questo file è sostituito da `catalog.routes.empty.ts` (fileReplacements in
 * angular.json): il codice del catalogo non entra nel bundle (research R-16).
 */
export const CATALOG_ROUTES: Routes = [
  {
    path: '_catalog',
    title: 'Catalogo dei componenti',
    data: { breadcrumb: 'Catalogo dei componenti' },
    loadComponent: () => import('./catalog.page').then((module) => module.CatalogPage),
  },
];
